import { NgModule }                from '@angular/core';
import { FormDatepickerComponent } from '@app/shared/form-elements/form-datepicker/form-datepicker.component';
import { NgbDatepickerModule }     from '@ng-bootstrap/ng-bootstrap';
import { DatePickerModule }        from '@shared/components/date-picker/date-picker.module';
import { MonthPickerModule }       from '@shared/components/month-picker/month-picker.module';
import { FormElementsModule }      from '@shared/form-elements/form-elements.module';
import { PipesModule }             from '@shared/pipes/pipes.module';

@NgModule( {
	declarations: [
		FormDatepickerComponent
	],
	imports: [
		FormElementsModule,
		NgbDatepickerModule,
		DatePickerModule,
		PipesModule,
		MonthPickerModule
	],
	exports: [
		FormDatepickerComponent
	]
} )
export class FormDatepickerModule {}
